<template>
  <div class="content login">
    <div class="title_top"></div>
    <!-- <div class="Log_out" @click="logoff()">退出登录</div> -->
    <div class="first_left">
      <div class="ziti">综合</div>
      <div class="parent">
        <div
          v-for="(item, index) in ZongHe"
          :key="index"
          :class="'div' + (index + 1)"
          class="divkj"
          :style="'background:url(' + item.bg_1 + ')'"
          @click="nodeClick(item)"
        >
          <img :src="item.bg_2" :style="item.img_style" />
          <div class="div_wenzi">
            {{ item.webName }}
          </div>
        </div>
      </div>
    </div>
    <div class="first_center">
      <div class="ziti">生产</div>
      <div class="parent2">
        <div
          v-for="(item, index) in ShengChan"
          :key="index"
          :class="'div' + (index + 1)"
          class="divkj"
          :style="'background:url(' + item.bg_1 + ')'"
          @click="nodeClick(item)"
        >
          <img :src="item.bg_2" :style="item.img_style" />
          <div class="div_wenzi">
            {{ item.webName }}
          </div>
        </div>
      </div>
    </div>
    <div class="first_right">
      <div class="ziti">管网</div>
      <div class="parent2">
        <div
          v-for="(item, index) in GuanWang"
          :key="index"
          :class="'div' + (index + 1)"
          class="divkj"
          :style="'background:url(' + item.bg_1 + ')'"
          @click="nodeClick(item)"
        >
          <img :src="item.bg_2" :style="item.img_style" />
          <div class="div_wenzi">
            {{ item.webName }}
          </div>
        </div>
      </div>
    </div>
    <div class="second_left">
      <div class="ziti">营销</div>
      <div class="parent3">
        <div
          v-for="(item, index) in YingXiao"
          :key="index"
          :class="'div' + (index + 1)"
          class="divkj"
          :style="'background:url(' + item.bg_1 + ')'"
          @click="nodeClick(item)"
        >
          <img :src="item.bg_2" :style="item.img_style" />
          <div class="div_wenzi">
            {{ item.webName }}
          </div>
        </div>
      </div>
    </div>
    <div class="second_center">
      <div class="ziti">客服</div>
      <div class="parent4">
        <div
          v-for="(item, index) in KeFu"
          :key="index"
          :class="'div' + (index + 1)"
          class="divkj"
          :style="'background:url(' + item.bg_1 + ')'"
          @click="nodeClick(item)"
        >
          <img :src="item.bg_2" :style="item.img_style" />
          <div class="div_wenzi">
            {{ item.webName }}
          </div>
        </div>
      </div>
    </div>
    <div class="second_right">
      <div class="ziti">工程</div>
      <div class="parent2">
        <div
          v-for="(item, index) in GongCheng"
          :key="index"
          :class="'div' + (index + 1)"
          class="divkj"
          :style="'background:url(' + item.bg_1 + ')'"
          @click="nodeClick(item)"
        >
          <img :src="item.bg_2" :style="item.img_style" />
          <div class="div_wenzi">
            {{ item.webName }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="logo_img"></div>
    <div class="rightbox">
      <template v-for="(item_y, y) in box_list[0].length">
        <template v-for="(item_x, x) in box_list.length">
          <div :key="x + '_' + y" :pos="x + '_' + y">
            <div
              v-if="box_list[x][y] != 0"
              class="empty menu_node"
              :style="{
                backgroundImage:
                  'url(' + require(`${box_list[x][y].bg_1}`) + ')',
                opacity: box_list[x][y].opacity ? box_list[x][y].opacity : 1,
              }"
              :class="{
                nopower_box:
                  !box_list[x][y].power && //权限false
                  box_list[x][y] != 0 && //有节点
                  box_list[x][y].item_type != 2, //非图标
                menu_node_hover: box_list[x][y].item_type != 2, //2是图标
                menu_img: box_list[x][y].item_type == 2, //图标
              }"
              @click="nodeClick(box_list[x][y])"
            >
              <p>{{ box_list[x][y].webName }}</p>
            </div>
            <div v-else></div>
          </div>
        </template>
      </template>
    </div> -->
    <div>
      <!--弹框-->
      <a-modal v-model="dialogVisible" title="提示" :footer="null">
        <div>您没有访问权限！</div>
        <div style="width: 100%; text-align: right; margin: 20px 0 5px 0">
          <a-button
            type="primary"
            @click="
              () => {
                dialogVisible = false;
              }
            "
            >确认</a-button
          >
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
// import { url } from "inspector";

export default {
  data() {
    return {
      timer: "",
      webtoken_list: [],
      menu_list: [],
      box_list: [],
      userRights: [],
      dialogVisible: false,
      quiturl: "/unilogin",
      All_data: [],
      ZongHe: [],
      ShengChan: [],
      GuanWang: [],
      YingXiao: [],
      KeFu: [],
      GongCheng: [],
    };
  },
  mounted: function () {
    // this.timer = setInterval(this.ping, manage.ping_time);
    this.All_data = manage.item;
    // //  debugger
    this.FenLei(this.All_data);
  },
  methods: {
    ping() {
      var that = this;
      manage.system.forEach((element) => {
        //不需要ping
        if (!element.need_ping) {
          return;
        }
        var system = that.webtoken_list.find((n) => {
          return n.id == element.id;
        });
        var path = element.defalut_ping_url;
        var headers = {
          token: system.token,
        };
        var params = { appIdentity: element.default_appIdentity };

        console.log(path, "path");
        console.log(headers, "headers");
        console.log(params, "params");

        this.public_function.h_Ajax(
          path,
          "get",
          params,
          headers,
          1,
          function (data) {
            if (!data) {
              that.logoff();
            }
          },
          function (err) {
            that.logoff();
          }
        );
      });
    },
    logoff() {
      this.$router.push({ path: "/unilogin" });
      // this.$store.commit("delToken");
      // this.$router.push({ path: this.quiturl });
    },
    get_data_list() {
      var that = this;
      this.get_menu_init();
      for (var i = 0; i < manage.item.length; i++) {
        that.get_data(i);
      }
    },
    get_data(i) {
      var that = this;
      //console.log(manage.item[i], i);
      var item_type = manage.item[i].item_type;
      //菜单类型判断
      if (item_type == 1 || manage.item[i].system_id == -1) {
        //越过权限
        console.log(i, manage.item[i].webName + "_特殊权限");
        that.openpower(i);
        return;
      }
      //純图标
      if (item_type == 2) {
        // console.log(
        //   i,
        //   (manage.item[i].webName == null ? "未命名" : manage.item[i].webName) +
        //     "_图标展示"
        // );
        that.openpower(i);
        return;
      }
      //得到带token平台
      var system = that.webtoken_list.find((n) => {
        return n.id == manage.item[i].system;
      });

      if (system.token == "") {
        //菜单token未找到
        return;
      }
      var headers = {
        // "Content-Type": "application/json;charset=UTF-8",
        token: system.token,
      };
      let path = system.url + system.menu + manage.item[i].code;

      this.public_function.h_Ajax(
        path,
        "get",
        {},
        headers,
        1,
        function (data) {
          if (data == null || data == [] || data.length == 0) {
            //当前菜单没权限
            return;
          } else if (
            data.findIndex((menu_node) => {
              return menu_node.authCode == "unilogin";
            }) > -1
          ) {
            // console.log(data, i);
            that.openpower(i);
          } else {
            return;
          }
        },
        function (data) {
          // 单次异常
          return;
        }
      );
    },
    get_menu() {
      var that = this;
      var new_menu = [];
      for (var i = 0; i < this.menu_list.length; i++) {
        var dataInfo = this.menu_list[i];
        //无权限码
        if (!dataInfo.authCode || dataInfo.authCode == undefined) continue;
        for (var z = 0; z < manage.item.length; z++) {
          var element = manage.item[z];
          if (element.code == dataInfo.authCode) {
            manage.item[z].power = dataInfo.authorized;
          }
        }
      }
      this.get_menu_init();
    },
    openpower(i) {
      var that = this;
      //普通权限的 判断token存在  //特殊的默认不判断
      if (manage.item[i].item_type == 0 && manage.item[i].system != -1) {
        var system = that.webtoken_list.find((n) => {
          return n.id == manage.item[i].system;
        });
        if (system == null) {
          console.log(i, "找不到所属平台");
        }
        if (system.token == "") {
          console.log(manage.item[i].webName + "无法开启权限，没有token");
          return;
        }
      }

      var x = manage.item[i].menu_position[0];
      var y = manage.item[i].menu_position[1];
      that.box_list[x][y].power = true;
      that.$forceUpdate();
    },
    test() {
      console.log(manage.ping_time);
      //this.ping();
    },
    //画出布局
    get_menu_init() {
      var max_x = 7;
      var max_y = 4;
      for (var x = 0; x < max_x; x++) {
        var box_list2 = [];
        for (var y = 0; y < max_y; y++) {
          box_list2.push(0);
        }
        this.box_list.push(box_list2);
      }
      manage.item.forEach((n) => {
        var x = n.menu_position[0];
        var y = n.menu_position[1];
        if (x < max_x && y < max_y) {
          var js_n = JSON.stringify(n);
          this.box_list[x][y] = JSON.parse(js_n);
        }
      });
      console.log(this.box_list, "___");
      this.$forceUpdate();
    },
    //点击菜单
    nodeClick(node) {
      var that = this;
      //得到所属平台
      var system = that.webtoken_list.find((n) => {
        return n.id == node.system;
      });
      // //不可点
      // if (node == 0 || node.item_type == 2) {
      //   return;
      // }
      // //无权限
      // if (!node.power) {
      //   that.dialogVisible = true;
      //   return;
      // }
      // if (node.webName == "退出登录") {
      //   that.logoff();
      //   return;
      // }
      // //没有token 的普通按钮  特殊默认不判断
      // if (system.token == "" && node.item_type == 0) {
      //   alert("该系统未成功获取token");
      //   return;
      // }
      //点击逻辑
      const url = node.webUrl;
      var open_url = "";
      var url_link = url.indexOf("?") > 0 ? "&" : "?";
      // if (node.istoken == true) {
      //   open_url = `${node.webUrl}${url_link}${node.queryName}`;
      // } else {
        open_url = `${node.webUrl}`;
      // }
      // debugger
      console.log(open_url, "跳转");
      window.open(open_url, "_blank");
      return;
    },
    FenLei(data) {
      let that = this;
      data.forEach((obj) => {
        // debugger
        if (obj.fenlei_type == 1) {
          that.ZongHe.push(obj);
          that.ZongHe.sort((star, next) => {
            // 按type的指定顺序排序
            var order = [
              "综合大屏",
              "资料信息",
              // "信息维护",
              "智慧供水",
              "工单系统",
              "人力资源",
              "设备资产",

              // "供水门户",
              // "供水运营",
            ];
            return order.indexOf(star.webName) - order.indexOf(next.webName);
          });
        } else if (obj.fenlei_type == 2) {
          that.ShengChan.push(obj);
          that.ShengChan.sort((star, next) => {
            // 按type的指定顺序排序
            var order = [
              "调度系统",
              "二次供水",
              "信息发布",
              "工单系统",
              "水质监测",
            ];
            return order.indexOf(star.webName) - order.indexOf(next.webName);
          });
        } else if (obj.fenlei_type == 3) {
          that.GuanWang.push(obj);
          that.GuanWang.sort((star, next) => {
            // 按type的指定顺序排序
            var order = [
              "漏损管理",
              "智慧管网",
              "阀门管理",
              "水力模型",
              "管网三维",
              "管网GIS",
              "日常巡检",
            ];
            return order.indexOf(star.webName) - order.indexOf(next.webName);
          });
        } else if (obj.fenlei_type == 4) {
          that.YingXiao.push(obj);
          that.YingXiao.sort((star, next) => {
            // 按type的指定顺序排序
            var order = ["营销系统", "大客户管理", "表务系统", "预审系统"];
            return order.indexOf(star.webName) - order.indexOf(next.webName);
          });
        } else if (obj.fenlei_type == 5) {
          that.KeFu.push(obj);
        } else if (obj.fenlei_type == 6) {
          that.GongCheng.push(obj);
        }
      });
    },
  },
  created: function () {
    // console.log("create");
    // var that = this;
    // let TOKEN = that.$store.getters.getToken;
    // if (!TOKEN) {
    //   // alert("token失效或登录失败！");
    //   that.$router.push({ path: "/unilogin" });
    //   return;
    // }
    // //console.log(TOKEN);
    // this.webtoken_list = JSON.parse(TOKEN);
    // this.get_data_list();
  },
  beforeDestroy() {
    // clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
body {
  margin: 0;
  overflow: hidden;
}
.content {
  background-image: url("../../../../public/img/抚顺水务-统一登录页面-切图/bg.jpg");
  // background-image: url("img/login/dlybg05.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  height: 100%;
  width: 100%;
  min-width: 930px;
}

/*登录页 样式开始*/
.login .body {
  float: left;
  width: 33vw;
  height: 330px;

  background-image: url(img/login/login.png);
  background-size: cover;
  position: fixed;
  top: calc(50% - 180px);
  left: 50%;
  padding: 30px;
}
.logo_img {
  background-image: url(img/login/logo.png);
  background-repeat: no-repeat;
  width: 25vw;
  height: calc(25vw * 124 / 359);
  position: fixed;
  top: calc(50% - (25vw * 124 / 359) / 2 - 3vh);
  left: 15%;
  background-size: 100%;
}
.login_img_text {
  border-left: 2px #838f99 solid;
  color: #838f99;
  top: calc(50% - 3.65vw);
  left: 22%;
  position: fixed;
  height: 6vw;
  padding-left: 1.8%;

  p:nth-child(1) {
    font-size: 1.8vw;
    font-weight: bold;
    line-height: 1.7vw;
    margin-top: 3.5%;
  }
  p:nth-child(2) {
    font-size: 1.2vw;
    line-height: 1.7vw;
  }
}
.rightbox {
  left: 39%;
  top: calc(50% - 16vw - 2px);
  position: fixed;
  width: calc(56vw + 16px);
  height: calc(32vw + 8px);
  display: grid;
  grid-template-columns: 8vw 8vw 8vw 8vw 8vw 8vw 8vw;
  grid-template-rows: 8vw 8vw 8vw 8vw;
  transform: scale(0.8);
}
.empty {
  width: 8vw;
  height: 8vw;
  margin: 1px;
  float: left;
  background-repeat: no-repeat;
  background-size: 100%;
  cursor: pointer;
}

.gray {
  background: #e9f3fc;
}
.clear {
  clear: both;
}

.nopower_box:after {
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.4);
}
/*加亮*/
.menu_node:hover:after {
  // position: absolute;
  // content: "";
  // left: 0;
  // right: 0;
  // top: 0;
  // bottom: 0;
  // z-index: 10;
  // background: rgba(255, 255, 255, 0.4);
}
/*纯图标 */
.menu_img {
  opacity: 0.4;
}
//移入样式
.menu_node {
  transform: scale(0.95);
  position: relative;
  > p {
    position: absolute;
    text-align: center;
    bottom: 0.6vw;
    width: 100%;
    color: #fff;
    margin-bottom: 0 !important;
  }
}
.menu_node_hover:hover {
  transform: scale(1.05);
  p {
    animation: sport 0.3s;
  }
}
@keyframes sport {
  0% {
    bottom: 0%;
    opacity: 1;
  }
  100% {
    bottom: 0.6vw;
    opacity: 1;
  }
}
.title_top {
  background: url("../../../../public/img/抚顺水务-统一登录页面-切图/title.png")
    no-repeat;
  background-size: 100% 60%;
  width: 24vw;
  height: 15vh;
  position: absolute;
  top: 2%;
  left: 5%;
}
.Log_out {
  background: url("../../../../public/img/抚顺水务-统一登录页面-切图/Log_out.png")
    no-repeat;
  background-size: 25% 100%;
  // width: 1vw;
  // height: 3vh;
  position: absolute;
  top: 10%;
  right: 16%;
  text-indent: 30px;
  color: #052993;
}
.first_left {
  height: 41%;
  width: 26.5%;
  position: absolute;
  left: 9.45%;
  top: 12.4%;
  .parent {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 22% 22% 22% 22%;
    grid-template-rows: 32% 33% 33%;
    grid-column-gap: 1%;
    grid-row-gap: 1%;
    .div1 {
      grid-area: 1 / 1 / 3 / 3;
    }
    .div2 {
      grid-area: 1 / 3 / 2 / 4;
    }
    .div3 {
      grid-area: 1 / 4 / 2 / 5;
    }
    .div4 {
      grid-area: 2 / 3 / 3 / 5;
    }
    .div5 {
      grid-area: 3 / 1 / 4 / 3;
    }
    .div6 {
      grid-area: 3 / 3 / 4 / 5;
    }
  }
}
.first_center {
  height: 41%;
  width: 22.5%;
  position: absolute;
  left: 38%;
  top: 12.4%;
  .parent2 {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: calc(98% / 4);
    grid-template-rows: calc(99% / 2);
    grid-column-gap: 1%;
    grid-row-gap: 1%;

    .div1 {
      grid-area: 1 / 1 / 3 / 3;
    }
    .div2 {
      grid-area: 1 / 3 / 2 / 5;
    }
    .div3 {
      grid-area: 2 / 3 / 3 / 5;
    }
  }
}
.first_right {
  height: 41%;
  width: 24.5%;
  position: absolute;
  left: 65%;
  top: 12.4%;
  .parent2 {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, 1fr);
    grid-column-gap: 1%;
    grid-row-gap: 1%;
    .div1 {
      grid-area: 1 / 1 / 3 / 3;
    }
    .div2 {
      grid-area: 3 / 1 / 5 / 3;
    }
  }
}
.second_left {
  height: 25%;
  width: 26.5%;
  position: absolute;
  left: 9.45%;
  top: 62.4%;
  .parent3 {
    width: 91%;
    height: 100%;
    display: grid;
    grid-template-columns: 32% 33% 33%;
    grid-template-rows: repeat(2, 49.5%);
    grid-column-gap: 1%;
    grid-row-gap: 1%;
    .div1 {
      grid-area: 1 / 1 / 3 / 2;
    }
    .div2 {
      grid-area: 1 / 2 / 2 / 4;
    }
    .div3 {
      grid-area: 2 / 2 / 3 / 4;
    }
    
  }
}
.second_center {
  height: 25%;
  width: 22.5%;
  position: absolute;
  left: 38%;
  top: 62.4%;
  .parent4 {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2, 49.5%);
    grid-template-rows: 1fr;
    grid-column-gap: 1%;
    grid-row-gap: 0px;
    .div1 {
      grid-area: 1 / 1 / 2 / 2;
    }
    .div2 {
      grid-area: 1 / 2 / 2 / 3;
    }
  }
}
.second_right {
  height: 25%;
  width: 24.5%;
  position: absolute;
  left: 65%;
  top: 62.4%;
  .parent2 {
    width: 100%;
    height: 100%;
    // display: grid;
    // grid-template-columns: repeat(2, 49.5%);
    // grid-template-rows: repeat(2, 49.5%);
    // grid-column-gap: 1%;
    // grid-row-gap: 1%;
    .div1 {
      // grid-area: 1 / 1 / 2 / 3;
    }
    .div2 {
      // grid-area: 1 / 2 / 2 / 3;
    }
  }
}
.ziti {
  // margin-left: 15px;
  font-size: 20px;
  font-weight: 500;
}
.divkj {
  width: 100%;
  height: 100%;
  background-size: 100% 100% !important;
}
.div_title {
  position: absolute;
}
// img {
//   width: 50%;
//   position: relative;
//   left: 26%;
//   top: 20%;
// }
.div_wenzi {
  position: sticky;
  text-align: center;
  top: 88%;
  color: white;
  font-size: 14px;
  line-height: 30px;
}
</style>
